import PageComponent from '../base/PageComponent';

export default class AppraisalPopup extends PageComponent {
    init() {
        this.addEvent('.button__request', 'click', e => this.showAppraisalForm(e));
        this.addEvent('.mobile-nav__link', 'click', e => this.showAppraisalForm(e));
        this.addEvent('.button__enquire', 'click', e => this.showEnquiryForm(e));
    }

    onWindowResize() {
        this.popupPosition();
    }

    showAppraisalForm(e){
        e.preventDefault();
        let headers = new Headers(),
            container = document.getElementById('popup-overlay');

        headers.append("X-Requested-With", "XMLHttpRequest");

        fetch('/home/RenderAppraisalPopup', {
            method: 'GET',
            headers: headers
        }).then(response => {
            return response.json();
        }).then(json => {
            if(json.Popup){
                container.innerHTML = json.Popup;
                container.style.display = 'block';
                this.addEvent('.popup-overlay', 'click', e => this.hidePopup(e));
            }
        });
    }

    showEnquiryForm(e){
        e.preventDefault();
        let headers = new Headers(),
            container = document.getElementById('popup-overlay');

        headers.append("X-Requested-With", "XMLHttpRequest");

        var url = window.location.href,
            parts = url.split('/'),
            propertyID = parts[parts.length-1];

        fetch('/home/RenderEnquiryPopup/' + propertyID, {
            method: 'GET',
            headers: headers
        }).then(response => {
            return response.json();
        }).then(json => {
            if(json.Popup){
                container.innerHTML = json.Popup;
                container.style.display = 'block';
                this.addEvent('.popup-overlay', 'click', e => this.hidePopup(e));
                this.popupPosition();
            }
        });
    }

    hidePopup(e){
        $(e.target).closest('#popup-overlay').hide();
    }

    popupPosition() {
        let windowHeight = $('.popup-overlay').height()/2,
            popupHeight = $('.enquiry-form').outerHeight()/2;

        if ($('.enquiry-form').length) {
            $('.enquiry-form').css('top', windowHeight-popupHeight);
        }
    }
}


// WEBPACK FOOTER //
// ./javascript/components/AppraisalPopup.js